import { gql } from "@apollo/client";

export const MUTATION_CREATE_GIFT_CARD = gql`
  mutation CreateGiftCard(
    $amount: Float
    $giftCardOfferObjectId: String
    $networkName: String
    $currency: CurrencyTypes
    $paymentId: String
  ) {
    createGiftCard(
      amount: $amount
      currency: $currency
      giftCardOfferObjectId: $giftCardOfferObjectId
      networkName: $networkName
      paymentId: $paymentId
    ) {
      id
      cardId
      offerId
      barCodeImageUrl
      barCodeType
      cardNumber
      cardPin
      createdAt
      reloadHistory {
        amount {
          fiat {
            value
          }
        }
        totalSaleAmount
        btcVoucherDetails {
          btcVoucherUserAmount
        }
        giftDetails {
          name
          emailAddress
          message
        }
      }
      offer {
        id
        offerId
        brandName
        networkName
        barCodeType
        presetAmounts
        instruction {
          locale
          text
        }
        productDescription {
          locale
          text
        }
        termsAndConditions {
          inAppCard {
            locale
            text
          }
        }
        reloadSettings {
          isReloadable
        }
        commissionSettings {
          grossCommissionAmount
          memberRewardAmount
          isPercentage
        }
        styleSettings {
          includeImageBorder
          isCustomImageUpload
        }
        images {
          imageUrl
        }
      }
    }
  }
`;
